export default import.meta.ROLLUP_FILE_URL_YJKemg05wisEj_99xTFLUA